import Button from "../../elements/CustomButton/CustomButton";
import Card from "../Card/Card";
import React from "react";

export const ContentLogoCard = ({ src }) => {
  // console.log("src", src);
  return (
    <Card
      title={
        <div>
          <img width="50%" alt="" src={src} />
        </div>
      }
      textCenter={true}
      ftTextCenter={true}
      stats={
        <Button wd block>
          <i className="fa fa-2x fa-edit" />
        </Button>
      }
    />
  );
};
